export default "__VITE_ASSET__21616e84__"